import { registerCollisionAnimation } from './CollisionAnimationRegistry';

registerCollisionAnimation('SONIC_WAVE', (ctx, e, config, progress, elapsed, globalHue, determineColor) => {
  for (let i = 0; i < 5; i++) {
    const r = e.radius + progress * 200 + i * 20;
    ctx.beginPath(); ctx.arc(e.pos.x, e.pos.y, r, 0, Math.PI * 2);
    ctx.strokeStyle = determineColor(i, 5);
    ctx.lineWidth = 2;
    ctx.globalAlpha = (1 - progress) / (i + 1);
    ctx.stroke();
  }
});
